import { c as _c } from "react/compiler-runtime";
import { googleLogIn } from '@/actions/auth/loginGoogle';
import Button from '@/components/core/Button';
import Icon from '@/components/core/Icon/Icon';
import Label from '@/components/core/Label/Label';
import Typography from '@/components/core/Typography';
import { useRouter } from '@/i18n/routing';
import { useGoogleLogin, useGoogleOAuth, useGoogleOneTapLogin } from '@react-oauth/google';
import { useGoogleAuthEnabled } from '@/context/GoogleAuthContext';
import { useTranslations } from 'next-intl';
import { useState } from 'react';
import styled from 'styled-components';
import { getUser } from '@/actions/account/getUser';
import { intersection } from 'lodash';
import { getQuickstartState } from '@/actions/account/getQuickstartState';
import { device } from '@/components/Media';
const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
    align-items: center;
    justify-content: center;

    @media ${device.laptopS} {
        width: 100%;
    }
`;
const GoogleButton = styled(Button)`
    height: auto;
    padding: 12px;

    @media ${device.laptopS} {
        width: 100%;
        justify-content: center;
    }
`;
const ErrorLabel = styled(Label)`
    background-color: ${({
  theme
}) => theme.colors.palette.red_100};
    padding: 12px;
    height: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
`;
const ErrorIcon = styled(Icon)`
    background-color: ${({
  theme
}) => theme.colors.palette.red_300};
    margin-top: 3px;
`;
const ErrorTypography = styled(Typography)`
    color: ${({
  theme
}) => theme.colors.palette.red_300};
`;
export const postLoginRedirect = (router, user) => {
  if (!user) {
    router.replace('/');
    return;
  }
  const firstStepsPermissions = ['api.topology.create', 'api.mass-actions.import', 'api.farms.update'];
  if (intersection(firstStepsPermissions, user.permissions).length < firstStepsPermissions.length) {
    router.replace('/');
    return;
  }
  getQuickstartState().then(quickStartState => {
    if ([quickStartState?.has_devices, quickStartState?.has_cells, quickStartState?.imported_devices].some(val => val === false)) {
      router.replace('/settings/quickstart');
    } else {
      router.replace('/');
    }
  }).catch(() => {
    router.replace('/');
  });
};
const GoogleAuth = t0 => {
  const $ = _c(35);
  const {
    variant: t1
  } = t0;
  const variant = t1 === undefined ? "SignIn" : t1;
  const t = useTranslations();
  const router = useRouter();
  const [error, setError] = useState("");
  const googleContext = useGoogleOAuth();
  const googleAuthEnabled = useGoogleAuthEnabled();
  let t2;
  if ($[0] !== router || $[1] !== t) {
    t2 = (code, token) => {
      googleLogIn(code, token).then(async () => {
        const user = await getUser();
        postLoginRedirect(router, user);
      }).catch(() => {
        setError(t("common.internalError"));
      });
    };
    $[0] = router;
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const handleLogIn = t2;
  let t3;
  if ($[3] !== handleLogIn) {
    t3 = credentialResponse => {
      handleLogIn(null, credentialResponse.credential);
    };
    $[3] = handleLogIn;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t) {
    t4 = () => {
      setError(t("auth.googleSignInServerError"));
    };
    $[5] = t;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t3 || $[8] !== t4) {
    t5 = {
      onSuccess: t3,
      onError: t4
    };
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  useGoogleOneTapLogin(t5);
  let t6;
  if ($[10] !== handleLogIn) {
    t6 = credentialResponse_0 => {
      handleLogIn(credentialResponse_0.code, null);
    };
    $[10] = handleLogIn;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  let t8;
  if ($[12] !== t) {
    t7 = errorResponse => {
      bb12: switch (errorResponse.error) {
        case "invalid_request":
        case "invalid_scope":
        case "unauthorized_client":
          {
            setError(t("auth.googleSignInUnknownError"));
            break bb12;
          }
        case "access_denied":
          {
            setError(t("auth.googleSignInClosed"));
            break bb12;
          }
        default:
          {
            setError(t("auth.googleSignInServerError"));
          }
      }
    };
    t8 = errorResponse_0 => {
      bb21: switch (errorResponse_0.type) {
        case "popup_closed":
          {
            setError(t("auth.googleSignInClosed"));
            break bb21;
          }
        case "popup_failed_to_open":
          {
            setError(t("auth.googleSignInFailedToOpen"));
            break bb21;
          }
        default:
          {
            setError(t("auth.googleSignInUnknownError"));
          }
      }
    };
    $[12] = t;
    $[13] = t7;
    $[14] = t8;
  } else {
    t7 = $[13];
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t6 || $[16] !== t7 || $[17] !== t8) {
    t9 = {
      flow: "auth-code",
      onSuccess: t6,
      onError: t7,
      onNonOAuthError: t8
    };
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  const login = useGoogleLogin(t9);
  if (!googleAuthEnabled) {
    return null;
  }
  let t10;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <Icon name="google" withoutMask={true} />;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  const t11 = `auth.google${variant}`;
  let t12;
  if ($[20] !== t || $[21] !== t11) {
    t12 = t(t11);
    $[20] = t;
    $[21] = t11;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== googleContext || $[24] !== login || $[25] !== t) {
    t13 = () => {
      if (googleContext && !googleContext.scriptLoadedSuccessfully) {
        setError(t("auth.googleSignInFailedToOpen"));
      } else {
        setError("");
      }
      login();
    };
    $[23] = googleContext;
    $[24] = login;
    $[25] = t;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== t12 || $[28] !== t13) {
    t14 = <GoogleButton variant="stroke" startAdornment={t10} innerText={t12} onClick={t13} />;
    $[27] = t12;
    $[28] = t13;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  let t15;
  if ($[30] !== error) {
    t15 = error && <ErrorLabel size="xs" noChildrenWrap={true}><ErrorIcon name="alert-triangle-light" noMask={true} /><ErrorTypography variant="uiType" size="xs" modifier="R">{error}</ErrorTypography></ErrorLabel>;
    $[30] = error;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  let t16;
  if ($[32] !== t14 || $[33] !== t15) {
    t16 = <Wrapper>{t14}{t15}</Wrapper>;
    $[32] = t14;
    $[33] = t15;
    $[34] = t16;
  } else {
    t16 = $[34];
  }
  return t16;
};
export default GoogleAuth;